import { render, staticRenderFns } from "./TeamsList.vue?vue&type=template&id=52ad852e&scoped=true"
import script from "./TeamsList.vue?vue&type=script&lang=js"
export * from "./TeamsList.vue?vue&type=script&lang=js"
import style0 from "./TeamsList.vue?vue&type=style&index=0&id=52ad852e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad852e",
  null
  
)

export default component.exports